import { Code, Puzzle, Shield, Sun, Rocket } from "components/icons/generated";

export const randomIconAndColor = () => {
  const icons = [Rocket, Code, Puzzle, Shield, Sun];
  const colors = [
    "var(--semantic-color-background-decoration-green-subdued)",
    "var(--semantic-color-background-decoration-blue-subdued)",
    "var(--semantic-color-background-decoration-turquoise-subdued)",
    "var(--semantic-color-background-decoration-fuchsia-subdued)",
    "var(--semantic-color-background-decoration-orange-subdued)",
  ];
  return {
    icon: icons[Math.floor(Math.random() * icons.length)],
    color: colors[Math.floor(Math.random() * colors.length)],
  };
};

const hardcodedUserGuideGroupColorsAndIcons = [
  {
    id: "foundations",
    icon: Sun,
    color: "var(--semantic-color-background-decoration-green-subdued)",
  },
  {
    id: "operational-safety",
    icon: Shield,
    color: "var(--semantic-color-background-decoration-blue-subdued)",
  },
  {
    id: "configuration-reuse",
    icon: Puzzle,
    color: "var(--semantic-color-background-decoration-turquoise-subdued)",
  },
  {
    id: "delivery-at-scale",
    icon: Rocket,
    color: "var(--semantic-color-background-decoration-fuchsia-subdued)",
  },
];

export const getHardcodedUserGuideGroupIconAndColor = (id: string) => {
  const colorAndIcon = hardcodedUserGuideGroupColorsAndIcons.find(
    (colorAndIcon) => colorAndIcon.id === id
  );
  if (!colorAndIcon) {
    return randomIconAndColor();
  }

  return {
    icon: colorAndIcon.icon,
    color: colorAndIcon.color,
  };
};
